import api from '../config/api';
import {
  SubscriptionStatus,
  CheckoutSessionResponse,
  CustomerPortalResponse,
  StripePublicKeyResponse,
  CanSubscribeResponse,
} from '../types/subscription';

const stripeService = {
  /**
   * Récupère la clé publique Stripe
   */
  getPublicKey: async (): Promise<string> => {
    const response = await api.get<StripePublicKeyResponse>('/api/stripe/public-key');
    return response.data.publicKey;
  },

  /**
   * Crée une session de paiement Stripe avec tier et billing cycle
   */
  createCheckoutSession: async (
    tier: 'ESSENTIEL' | 'PREMIUM',
    billingCycle: 'MONTHLY' | 'YEARLY'
  ): Promise<string> => {
    const response = await api.post<CheckoutSessionResponse>('/api/stripe/create-checkout-session', {
      tier,
      billingCycle,
    });
    return response.data.checkoutUrl;
  },

  /**
   * Crée un portail client pour gérer l'abonnement
   */
  createCustomerPortal: async (): Promise<string> => {
    const response = await api.post<CustomerPortalResponse>('/api/stripe/create-customer-portal');
    return response.data.portalUrl;
  },

  /**
   * Vérifie si l'utilisateur peut s'abonner
   */
  canSubscribe: async (): Promise<CanSubscribeResponse> => {
    const response = await api.get<CanSubscribeResponse>('/api/stripe/can-subscribe');
    return response.data;
  },

  /**
   * Récupère le statut d'abonnement complet
   */
  getSubscriptionStatus: async (): Promise<SubscriptionStatus> => {
    const response = await api.get<SubscriptionStatus>('/api/subscription/status');
    return response.data;
  },

  /**
   * Vérifie l'accès actif de l'utilisateur
   */
  checkAccess: async (): Promise<{ hasActiveAccess: boolean }> => {
    const response = await api.get<{ hasActiveAccess: boolean }>('/api/subscription/check-access');
    return response.data;
  },
};

export default stripeService;
